import { Link } from 'react-router-dom';

import logoImg from './../../assets/logo.svg';

export function Logo({ className }: { className?: string }) {
  return (
    <div className={className ? className : 'logo'}>
      <Link to="/">
        <img src={logoImg} alt="numique" />
      </Link>
    </div>
  );
}
